"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FixedStreamStationHeader = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const fixedStreamSelectors_1 = require("../../../store/fixedStreamSelectors");
const dateFormat_1 = require("../../../types/dateFormat");
const DataSource_1 = require("./atoms/DataSource");
const StationActionButtons_1 = require("./atoms/StationActionButtons");
const StationName_1 = require("./atoms/StationName");
const StreamUpdate_1 = require("./atoms/StreamUpdate");
const ValueLabel_1 = require("./atoms/ValueLabel");
const S = __importStar(require("./FixedStreamStationHeader.style"));
const FixedStreamStationHeader = () => {
    const { unitSymbol, title, profile, sensorName, lastUpdate, updateFrequency, lastMeasurementValue, lastMeasurementDateLabel, active, sessionId, startTime, endTime, } = (0, react_redux_1.useSelector)(fixedStreamSelectors_1.selectFixedStreamShortInfo);
    const streamEndTime = endTime !== null && endTime !== void 0 ? endTime : (0, moment_1.default)().format(dateFormat_1.DateFormat.default);
    return (react_1.default.createElement(S.GridContainer, null,
        react_1.default.createElement(ValueLabel_1.ValueLabel, { date: lastMeasurementDateLabel, value: lastMeasurementValue, unitSymbol: unitSymbol, isActive: active }),
        react_1.default.createElement(StationName_1.StationName, { stationName: title }),
        react_1.default.createElement(DataSource_1.DataSource, { profile: profile, sensorName: sensorName }),
        react_1.default.createElement(StreamUpdate_1.StreamUpdate, { lastUpdate: lastUpdate, updateFrequency: updateFrequency, startTime: startTime, endTime: streamEndTime }),
        react_1.default.createElement(StationActionButtons_1.StationActionButtons, { sessionId: sessionId })));
};
exports.FixedStreamStationHeader = FixedStreamStationHeader;
